import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'
import { Link } from 'react-router-dom'

import style from '../style'

export const SignupSection = props => {
  return (
    <Container>
      <Row>
        <Col xs='12' md='9'>
          <h3 className={css(style.signup.h3)}>Ready To Get Started?</h3>
          <p className={css(style.signup.p)}>
            Your community is there, let it pay for itself!
          </p>
        </Col>
        <Col xs='12' md='3' className={`d-flex align-items-center`}>
          <Link to='/signup' className={css(style.signup.link)}>
            Signup Now!
          </Link>
        </Col>
      </Row>
    </Container>
  )
}

export default SignupSection



// WEBPACK FOOTER //
// ./src/components/Home/partials/signup.js